/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_Empty_HintInputs */

const fr_rooms_empty_hint = /** @type {(inputs: Rooms_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune chambre configurée. Ajoutez-en pour générer un mini widget.`)
};

const en_rooms_empty_hint = /** @type {(inputs: Rooms_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No room configured. Add one to generate a mini widget.`)
};

/**
* | output |
* | --- |
* | "No room configured. Add one to generate a mini widget." |
*
* @param {Rooms_Empty_HintInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const rooms_empty_hint = /** @type {((inputs?: Rooms_Empty_HintInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_Empty_HintInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_rooms_empty_hint(inputs)
	return en_rooms_empty_hint(inputs)
});